export default __webpack_public_path__ + "static/media/KSUM-template.67be51b2.png";